module.exports = __webpack_public_path__ + "6b03af09db02d2cf7f309724b9c50a05.jpg";